/**
 * CatalogoService
 * Servicio para manejar las operaciones del catálogo jerárquico (Áreas, Partidas, Recursos)
 */

import api from './api';

const API_BASE_URL = (() => {
  const baseURL = api?.defaults?.baseURL || '/api/content';
  return baseURL.replace(/\/content\/?$/i, '/onebase');
})();

// ============================================
// SERVICIO PARA ÁREAS
// ============================================

export const areaService = {
  getAll: (filters = {}) => {
    return api.get(`${API_BASE_URL}/areas/`, {
      params: filters,
    });
  },

  getById: (id) => {
    return api.get(`${API_BASE_URL}/areas/${id}/`);
  },

  create: (data) => {
    return api.post(`${API_BASE_URL}/areas/`, data);
  },

  update: (id, data) => {
    return api.patch(`${API_BASE_URL}/areas/${id}/`, data);
  },

  delete: (id) => {
    return api.delete(`${API_BASE_URL}/areas/${id}/`);
  },
};

// ============================================
// SERVICIO PARA PARTIDAS
// ============================================

export const partidaService = {
  getAll: (filters = {}) => {
    return api.get(`${API_BASE_URL}/partidas/`, {
      params: filters,
    });
  },

  getById: (id) => {
    return api.get(`${API_BASE_URL}/partidas/${id}/`);
  },

  create: (data) => {
    return api.post(`${API_BASE_URL}/partidas/`, data);
  },

  update: (id, data) => {
    return api.patch(`${API_BASE_URL}/partidas/${id}/`, data);
  },

  delete: (id) => {
    return api.delete(`${API_BASE_URL}/partidas/${id}/`);
  },

  getByArea: (areaId, filters = {}) => {
    return api.get(`${API_BASE_URL}/partidas/`, {
      params: {
        area: areaId,
        ...filters,
      },
    });
  },
};

// ============================================
// SERVICIO PARA TIPOS DE RECURSO
// ============================================

export const tipoRecursoService = {
  getAll: (filters = {}) => {
    return api.get(`${API_BASE_URL}/tipos-recurso/`, {
      params: filters,
    });
  },

  getById: (id) => {
    return api.get(`${API_BASE_URL}/tipos-recurso/${id}/`);
  },

  create: (data) => {
    return api.post(`${API_BASE_URL}/tipos-recurso/`, data);
  },

  update: (id, data) => {
    return api.patch(`${API_BASE_URL}/tipos-recurso/${id}/`, data);
  },

  delete: (id) => {
    return api.delete(`${API_BASE_URL}/tipos-recurso/${id}/`);
  },
};

// ============================================
// SERVICIO PARA RECURSOS
// ============================================

export const recursoService = {
  getAll: (filters = {}) => {
    return api.get(`${API_BASE_URL}/recursos/`, {
      params: filters,
    });
  },

  getById: (id) => {
    return api.get(`${API_BASE_URL}/recursos/${id}/`);
  },

  create: (data) => {
    return api.post(`${API_BASE_URL}/recursos/`, data);
  },

  update: (id, data) => {
    return api.patch(`${API_BASE_URL}/recursos/${id}/`, data);
  },

  delete: (id) => {
    return api.delete(`${API_BASE_URL}/recursos/${id}/`);
  },

  getByPartida: (partidaId, filters = {}) => {
    return api.get(`${API_BASE_URL}/recursos/`, {
      params: {
        partida: partidaId,
        ...filters,
      },
    });
  },
};

export default {
  areaService,
  partidaService,
  tipoRecursoService,
  recursoService,
};
